import React, { useEffect, useRef, useState, FC } from 'react';
import { StyledSearchCloseButton, StyledSearchInputDesktop } from '../N20MainMenu/styled';
import { useTranslation } from '~/shared/utils/translation';
import { useSearchStore } from '~/services/search/useSearchStore';
import { useRouter } from 'next/router';
import { UseSearchBoxProps } from 'react-instantsearch';

import CloseIcon from '~/icons/close.svg';
import { SearchPlaceholderComponent } from './SearchPlaceholderComponent';
import { SearchDataHooks } from './SearchDataHooks';
import { closeMenu } from '../N30MegaMenu/MegaMenu';

type ISearchBoxProps = UseSearchBoxProps & {
    onSubmitSearch: (searchQuery: string, redirectUrl?: string) => void;
};

export const SearchInput: FC<ISearchBoxProps> = ({ onSubmitSearch }) => {
    const inputRef = useRef<HTMLInputElement>(null);
    const [query, setQuery] = useState('');
    const { query: params } = useRouter();
    const { translate } = useTranslation();
    const { setShowSearch, showSearchPage } = useSearchStore();

    useEffect(() => {
        if (!showSearchPage) {
            setQuery('');
            setShowSearch(false);
        } else {
            closeMenu();
        }
    }, [showSearchPage]);

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const newQuery = e.target.value;
        if (!newQuery) {
            setQuery('');
            setTimeout(() => inputRef?.current?.focus());
            return;
        }
        setQuery(newQuery);
    };

    const handleClose = () => {
        setShowSearch(false);
        setTimeout(() => inputRef?.current?.blur());
    };

    return (
        <>
            {showSearchPage && (
                <SearchDataHooks
                    query={query}
                    inputRef={inputRef}
                    onSubmitSearch={onSubmitSearch}
                />
            )}

            <SearchPlaceholderComponent
                icon={showSearchPage ? 'arrowLeft' : 'search'}
                onClick={handleClose}
            >
                {!showSearchPage && translate('header.search')}
            </SearchPlaceholderComponent>

            <StyledSearchInputDesktop
                aria-label="Search"
                value={query}
                defaultValue={params.query}
                onFocus={() => setShowSearch(true)}
                onChange={handleChange}
                withLabel={false}
                ref={inputRef}
                data-testid="search-input"
            />
            {query && (
                <StyledSearchCloseButton
                    aria-label="Close"
                    size="small"
                    onClick={() => setQuery('')}
                    variant="plain"
                >
                    <CloseIcon />
                </StyledSearchCloseButton>
            )}
        </>
    );
};
